import { useMemo, useEffect, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import { useTranslation } from 'react-i18next';
import { Divider } from "@mui/material";
import Utility from "../utility/utility";

function BhavaDataView({ tableData }) {
    const { t } = useTranslation();

    const dataTableData = {
        columns: [
            { Header: t("Bhavaya"), accessor: "bhavaIndex" },
            { Header: t("Rashiya"), accessor: "rasi" },
            { Header: t("Place"), accessor: "place" },
            { Header: t("Nekatha"), accessor: "nekatha" },
            { Header: t("UpaGraha"), accessor: "upaGraha" },
            { Header: t("UpaUpaGraha"), accessor: "upaUpaGraha" },
            { Header: t("UpaUpaUpaGraha"), accessor: "upaUpaUpaGraha" },
            { Header: t("GahasInBhava"), accessor: "gahasInBhava" },
        ],
        rows: tableData
    }

    return (
        <MDBox pt={0} pb={1} id="planets-ref">
            <MDBox mb={1}>
                <Card>
                    {/* <MDBox p={3} lineHeight={1} mb={0} display="flex" alignItems="center">
                        <MDTypography variant="h5" fontWeight="medium">
                            ග්‍රහස්ථුට
                        </MDTypography>
                        <Divider variant="fullWidth" sx={{ flexGrow: 1, marginLeft: 2 }} />
                    </MDBox> */}
                    <DataTable
                        canSearch={false}
                        entriesPerPage={false}
                        showTotalEntries={false}
                        table={dataTableData} />
                </Card>
            </MDBox>
        </MDBox>
    );
};

BhavaDataView.propTypes = {
    tableData: PropTypes.any
};

export default BhavaDataView;